// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__Aa4o2","dark":"Toggle_dark__0cPa-","disabled":"Toggle_disabled__MWAxj"};